const GAEvents = require('./ga-events');

const Video = {
  init() {
    const videosArray = document.querySelectorAll("video");

    videosArray.forEach(video => {
      video.addEventListener("playing", (event) => {
        GAEvents.sendEvent('click in', 'Video Block Click', document.title);
      });


      // Fixing "click to start video" native behaviour on mobile
      video.addEventListener("touchstart", (event) => {
        if (video.paused || video.ended) {
          video.play();
        } else {
          video.pause();
        }
      }, {passive: true});
    });
  },
};

module.exports = Video;
